import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import { Observable } from 'rxjs';

@Injectable()
export class InterestZonesService {
  private readonly _http = inject(HttpClient);

  updateZoneStatus(zoneId: number): Observable<void> {
    return this._http.patch<void>(
      `${environment.dispatchUrl}/interest-zones/update-status/${zoneId}`,
      {}
    );
  }

  deleteZone(zoneId: number): Observable<void> {
    return this._http.delete<void>(
      `${environment.dispatchUrl}/interest-zones/${zoneId}`
    );
  }
}
